import React from 'react';

import Home from '../containers/home/Home';
import CameraCaller from '../containers/camera_caller/CameraCaller';
import Preview from '../containers/preview/Preview';
import Instruction from '../containers/instruction/Instruction';
import Signature from '../containers/signature/Signature';
import Result from '../containers/result/Result';
import CameraRecord from "../containers/camera_record/CameraRecord";
import Error from '../containers/error/Error';
import Final from '../containers/final/Final';
import config from '../config/config';
import Initial from '../containers/initial/Initial';
import Authentication from '../containers/authentication/Authentication';
import ConfirmationClauses from '../containers/confirmation_clauses/ConfirmationClauses';
import NotaryDeclaration from '../containers/notary_declaration/NotaryDeclaration';
import SelectIdentityCardType from "../containers/select_identity_card_type/SelectIdentityCardType";
import SecurityCaller from "../containers/security_caller/SecurityCaller";
import SelectAuthenticationType from "../containers/select_authentication_type/SelectAuthenticationType";
import SelectAuthenticationTypeClaveUnicaPriority from "../containers/select_authentication_type_clave_unica_priority/SelectAuthenticationTypeClaveUnicaPriority";
import AuthorizationQuestions from "../containers/questions/AuthorizationQuestions";
import AdvancedElectronicSignature from '../containers/advanced_electronic_signature/AdvancedElectronicSignature';
import AdvancedElectronicSignatureValidation from '../containers/advanced_electronic_signature_validation/AdvancedElectronicSignatureValidation';
import DocumentReview from '../containers/document_review/DocumentReview';
import RekognitionFaceLivenessInit from '../containers/rekognition_face_liveness_init/RekognitionFaceLivenessInit';
import CameraWithFraming from '../containers/camera_with_framing/CameraWithFraming';
import InstructionCaptureIdentityCard from '../containers/instruction_capture_identity_card/InstructionCaptureIdentityCard';
import CameraFramingSingle from '../containers/camera_framing_single/CameraFramingSingle';
import ThumbFingerprintCapture from '../containers/thumb_fingerprint_capture/ThumbFingerprintCapture';

class Step {
    data = {
        home: {
            value: 'home',
            errorType: 'default',
            getData: (value) => {
                return {};
            },
            component: (actions) => {
                return (
                    <Home
                        hasCode={true}
                        startAction={actions.start}
                    />
                );
            }
        },
        authentication: {
            value: 'authentication',
            errorType: 'default',
            getData: (value) => {
                return {};
            },
            component: (actions) => {
                return (
                    <Authentication login={actions.login}/>
                );
            }
        },
        home_without_code: {
            value: 'home_without_code',
            errorType: 'default',
            getData: (value) => {
                return {};
            },
            component: (actions) => {
                return (
                    <Home
                        hasCode={false}
                        time={config.process_time}
                        unit={config.process_time_unit_label}
                        accessAction={actions.access}
                    />
                );
            }
        },
        initial: {
            value: 'initial',
            errorType: 'default',
            getData: (value) => {
                return {};
            },
            component: (actions) => {
                return (
                    <Initial nextStep={actions.next}/>
                );
            }
        },
        capture_identity_card_front: {
            value: 'capture_identity_card_front',
            errorType: 'default',
            getData: (value) => {
                return {};
            },
            component: (actions) => {
                return (
                    <CameraCaller nextStep={actions.next}
                            showLoader={actions.showLoader}
                    />

                );
            }
        },
        preview_identity_card_front: {
            value: 'preview_identity_card_front',
            errorType: 'IdentityCardFrontCapture',
            getData: (value) => {
                return {
                    file: value
                };
            },
            errorType: 'IdentityCardFrontCapture',
            component: (actions) => {
                return (
                    <Preview nextStep={actions.next}
                             showLoader={actions.showLoader}
                    />
                );
            }

        },
        capture_identity_card_back: {
            value: 'capture_identity_card_back',
            errorType: '',
            getData: (value) => {
                return {};
            },
            component: (actions) => {
                return (
                    <CameraCaller nextStep={actions.next}
                            showLoader={actions.showLoader}
                    />
                );
            }
        },
        preview_identity_card_back: {
            value: 'preview_identity_card_back',
            errorType: 'IdentityCardBackCapture',
            getData: (value) => {
                return {
                    file: value
                };
            },
            component: (actions) => {
                return (
                    <Preview nextStep={actions.next}
                             showLoader={actions.showLoader}
                    />
                );
            }
        },
        capture_photo: {
            value: 'capture_photo',
            errorType: '',
            getData: (value) => {
                return {};
            },
            component: (actions) => {
                return (
                    <CameraCaller nextStep={actions.next}
                            showLoader={actions.showLoader}
                    />
                );
            }
        },
        preview_capture_photo: {
            value: 'preview_capture_photo',
            errorType: 'faceCapture',
            getData: (value) => {
                return {
                    file: value
                };
            },
            component: (actions) => {
                return (
                    <Preview nextStep={actions.next}
                             showLoader={actions.showLoader}
                    />
                );
            }
        },
        capture_circulation_permission: {
            value: 'capture_circulation_permission',
            errorType: '',
            getData: (value) => {
                return {};
            },
            component: (actions) => {
                return (
                    <CameraCaller nextStep={actions.next}
                                  showLoader={actions.showLoader}
                    />
                );
            }
        },
        preview_circulation_permission: {
            value: 'preview_circulation_permission',
            errorType: 'default',
            getData: (value) => {
                return {
                    file: value
                };
            },
            component: (actions) => {
                return (
                    <Preview nextStep={actions.next}
                             showLoader={actions.showLoader}
                             isStepPreviewCirculationPermission={true}
                    />
                );
            }
        },
        instruction: {
            value: 'instruction',
            errorType: 'default',
            getData: (value) => {
                return {};
            },
            component: (actions) => {
                return (
                    <Instruction nextStep={actions.next}
                                 buttonText={'Continuar'}
                    />
                )
            }
        },
        handwritten_signature_capture: {
            value: 'handwritten_signature_capture',
            errorType: 'finalAnalysis',
            getData: (value) => {
                return {
                    file: value
                };
            },
            component: (actions) => {
                return (
                    <Signature nextStep={actions.next}/>
                );
            }
        },
        capture_video: {
            value: 'capture_video',
            errorType: 'default',
            getData: (value) => {
                return {
                    video: value
                };
            },
            component: (actions) => {
                return (
                    <CameraRecord nextStep={actions.next}/>
                );
            }
        },
        capture_video_notary_declaration: {
            value: 'capture_video_notary_declaration',
            errorType: 'default',
            getData: (value) => {
                return {
                    video: value
                };
            },
            component: (actions) => {
                return (
                    <NotaryDeclaration nextStep={actions.next}/>
                );
            }
        },
        result_process: {
            value: 'result_process',
            errorType: 'default',
            getData: (value) => {
                return {};
            },
            component: (actions) => {
                return (
                    <Result nextStep={actions.next}/>
                );
            }
        },
        final: {
            value: 'final',
            errorType: 'default',
            getData: (value) => {
                return {};
            },
            component: (actions) => {
                return (
                    <Final/>
                );
            }
        },
        contract: {
            value: 'contract',
            errorType: 'default',
            getData: (value) => {
                return {};
            },
            component: (actions) => {
                return (
                    <DocumentReview nextStep={actions.next}
                                    buttonText={'Continuar'}
                                    processResumeComponent={true}
                                    pdfViewerComponent={true}
                                    clauseAndNextButton={true}
                                    downloadDocument={true}
                    />
                );
            }
        },
        capture_mandate_signed: {
            value: 'capture_mandate_signed',
            errorType: 'default',
            getData: (value) => {
                return {
                    file: value
                };
            },
            component: (actions) => {
                return (
                    <Preview nextStep={actions.next}
                             showLoader={actions.showLoader}
                    />
                );
            }
        },
        confirmation_clauses: {
            value: 'confirmation_clauses',
            errorType: 'default',
            getData: (value) => {
                return {
                    ...value
                };
            },
            component: (actions) => {
                return (
                    <ConfirmationClauses
                        nextStep={actions.next}
                        buttonText={'Continuar'}
                    />
                );
            }
        },
        error: {
            value: 'error',
            errorType: 'default',
            getData: (value) => {
                return {};
            },
            component: (actions) => {
                return (
                    <Error/>
                );
            }
        },
        select_identity_card_type: {
            value: 'select_identity_card_type',
            errorType: 'default',
            getData: (value) => {
                return {
                    ...value
                };
            },
            component: (actions) => {
                return (
                  <SelectIdentityCardType
                    nextStep={actions.next}
                    showLoader={actions.showLoader}
                  />

                );
            }
        },
        select_authentication_type: {
            value: 'select_authentication_type',
            errorType: 'default',
            getData: (value) => {
                return {
                    ...value
                };
            },
            component: (actions) => {
                return (
                  <SelectAuthenticationType nextStep={actions.next}
                                showLoader={actions.showLoader}
                  />

                );
            }
        },
        select_authentication_type_clave_unica_priority: {
            value: 'select_authentication_type_clave_unica_priority',
            errorType: 'default',
            getData: (value) => {
                return {
                    ...value
                };
            },
            component: (actions) => {
                return (
                  <SelectAuthenticationTypeClaveUnicaPriority nextStep={actions.next}
                                showLoader={actions.showLoader}
                  />

                );
            }
        },
        autocapture_identity_card_back: {
            value: 'autocapture_identity_card_back',
            errorType: 'default',
            getData: (value) => {
                return {
                    ...value
                };
            },
            component: (actions) => {
                return (
                  <SecurityCaller
                    nextStep={actions.next}
                    showLoader={actions.showLoader}
                    processType={'autocapture'}
                    cardSide={'back'}
                  />

                );
            }
        },
        autocapture_identity_card_front: {
            value: 'autocapture_identity_card_front',
            errorType: 'default',
            getData: (value) => {
                return {
                    ...value
                };
            },
            component: (actions) => {
                return (
                  <SecurityCaller
                    nextStep={actions.next}
                    showLoader={actions.showLoader}
                    processType={'autocapture'}
                    cardSide={'front'}
                  />

                );
            }
        },
        autocapture_face_liveness: {
            value: 'autocapture_face_liveness',
            errorType: 'default',
            getData: (value) => {
                return {
                    ...value
                };
            },
            component: (actions) => {
                return (
                  <SecurityCaller
                    nextStep={actions.next}
                    showLoader={actions.showLoader}
                    processType={'liveness'}
                  />
                );
            }
        },
        autocapture_face_liveness_light_security: {
            value: 'autocapture_face_liveness_light_security',
            errorType: 'default',
            getData: (value) => {
                return {
                    ...value
                };
            },
            component: (actions) => {
                return (
                  <SecurityCaller
                    nextStep={actions.next}
                    showLoader={actions.showLoader}
                    processType={'liveness'}
                  />
                );
            }
        },
        authorization_questions: {
            value: 'authorization_questions',
            errorType: 'default',
            getData: (value) => {
                return {
                    ...value
                };
            },
            component: (actions) => {
                return (
                  <AuthorizationQuestions
                    nextStep={actions.next}
                    showLoader={actions.showLoader}
                  />
                );
            }
        },
        advanced_electronic_signature:{
            value: 'advanced_electronic_signature',
            errorType: 'default',
            getData: (value) => {
                return {
                    ...value
                };
            },
            component: (actions) => {
                return (
                  <AdvancedElectronicSignature nextStep={actions.next}
                                               buttonText={'Continuar'}
                  />
                );
            }
        },
        advanced_electronic_signature_validation:{
            value: 'advanced_electronic_signature_validation',
            errorType: 'default',
            getData: (value) => {
                return {
                    ...value
                };
            },
            component: (actions) => {
                return (
                  <AdvancedElectronicSignatureValidation nextStep={actions.next}
                                                         buttonText={'Continuar'}
                  />
                );
            }
        },
        document_review: {
            value: 'document_review',
            errorType: 'default',
            getData: (value) => {
                return {};
            },
            component: (actions) => {
                return (
                    <DocumentReview backButton={true}
                                    viewDocumentButton={true}
                                    processResumeComponent={true}
         />
                );
            }
        },
        rekognition_face_liveness_init:{
            value: 'rekognition_face_liveness_init',
            errorType: 'default',
            getData: (value) => {
                return {
                    ...value
                };
            },
            component: (actions) => {
                return (
                  <RekognitionFaceLivenessInit nextStep={actions.next}
                                                         buttonText={'Continuar'}
                  />
                );
            }
        },
        capture_identity_card_front_with_framing_single:{
            value: 'capture_identity_card_front_with_framing_single',
            errorType: 'IdentityCardFrontCapture',
            getData: (value) => {
                if(typeof value == "object"){
                    return {scores: {...value}}
                }
                return {
                    file: value,
                };
            },
            component: (actions) => {
                return (
                
                    <CameraFramingSingle nextStep={actions.next}
                        buttonText={'Continuar'}
                    />
                );
            }
        },
        capture_identity_card_front_with_framing:{
            value: 'capture_identity_card_front_with_framing',
            errorType: 'default',
            getData: (value) => {
                if(typeof value == "object"){
                    return {scores: {...value}}
                }
                return {
                    file: value,
                };
            },
            component: (actions) => {
                return (
                  <CameraWithFraming nextStep={actions.next}
                    buttonText={'Continuar'}
                  />
                );
            }
        },
        capture_identity_card_back_with_framing_single:{
            value: 'capture_identity_card_back_with_framing_single',
            errorType: 'IdentityCardBackCapture',
            getData: (value) => {
                if(typeof value == "object"){
                    return {scores: {...value}}
                }
                return {
                    file: value,
                };
            },
            component: (actions) => {
                return (
                  <CameraFramingSingle nextStep={actions.next}
                        buttonText={'Continuar'}
                    />
                );
            }
        },
        capture_identity_card_back_with_framing:{
            value: 'capture_identity_card_back_with_framing',
            errorType: 'default',
            getData: (value) => {
                if(typeof value == "object"){
                    return {scores: {...value}}
                }
                return {
                    file: value,
                };
            },
            component: (actions) => {
                return (
                  <CameraWithFraming nextStep={actions.next}
                    buttonText={'Continuar'}
                  />
                );
            }
        },
        instruction_capture_identity_card:{
            value: 'instruction_capture_identity_card',
            errorType: 'default',
            getData: (value) => {
                return {};
            },
            component: (actions) => {
                return (
                  <InstructionCaptureIdentityCard nextStep={actions.next}
                    buttonText={'Continuar'}
                  />
                );
            }
        },
        thumb_fingerprint_capture: {
            value: 'thumb_fingerprint_capture',
            errorType: 'default',
            getData: (value) => {
                if(typeof value == "object"){
                    return {scores: {...value}}
                }
                return {
                    file: value
                };
            },
            component: (actions) => {
                return (
                    <ThumbFingerprintCapture nextStep={actions.next} />
                );
            }
        },
    }
}

export default new Step();